export default __webpack_public_path__ + "static/media/calendar.455d4243.svg";